<template>
  <v-app>
    <v-container id="password_reset">
      <v-layout
        align-center
        justify-center
      >
        <PasswordReset />
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import PasswordReset from "../../shared/components/PasswordReset";

export default {
  components: {
    PasswordReset
  }
};
</script>

<style>
</style>